import { GetterTree } from 'vuex';
import { VacationState } from './types';
import { RootState } from '@/store/types';
import { VacationQueryParams } from '@/api/requests/vacation/types';

export const getters: GetterTree<VacationState, RootState> = {

    /**
     * Check if vacation module is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    vacationModuleEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('vacations');
    },

    /**
     * Check if vacation change status permission is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    vacationChangeStatusEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('vacations.changeStatus');
    },

    /**
     * Get the active vacation.
     *
     * @param state
     * @param myGetters
     */
    activeVacation: (state, myGetters) => {
        return myGetters.getVacationById(state.activeVacationId);
    },

    /**
     * Return the specified vacation.
     *
     * @param state
     */
    getVacationById: (state) => (id: number) => {
        return state.vacations.find((vacation) => vacation.id === id);
    },

    /**
     * Check if vacation is in collection.
     *
     * @param state
     * @param myGetters
     */
    isVacationLoaded: (state, myGetters) => (id: number): boolean => {
        return !!myGetters.getVacationById(id);
    },

    /**
     * Get the active user vacation hour.
     *
     * @param state
     * @param myGetters
     */
    activeUserVacationHour: (state, myGetters) => {
        return myGetters.getUserVacationHourById(state.activeUserVacationHourId);
    },

    /**
     * Return the specified user vacation hour.
     *
     * @param state
     */
    getUserVacationHourById: (state) => (id: number) => {
        return state.userVacationHours.find((userVacationHour) => userVacationHour.id === id);
    },

    /**
     * Check if price list is in collection.
     *
     * @param state
     * @param myGetters
     */
    isUserVacationHourLoaded: (state, myGetters) => (id: number): boolean => {
        return !!myGetters.getUserVacationHourById(id);
    },



    /**
     * Get http filters.
     *
     * @param state
     */
    httpFilters: (state): VacationQueryParams => ({
        ...state.filters,
        vacation_start: state.filters.vacation_start,
        vacation_end: state.filters.vacation_end,
    }),




};
